import { httpClient, setResponseType } from '@/app/shared/services';
import { apiConstants } from '../config';
import { CLIENT_API_CREDENTIALS } from '@/config';


// import { billingMock } from '../../../../assets/mocks/billing.mock';
import { creditCardsMock } from '../../../../assets/mocks/creditCards.mock';
// import { prefixMock } from '../../../../assets/mocks/prefix.mock';
// import { addressMock } from '../../../../assets/mocks/address.mock';
// import { notificationsClientMock } from '@/assets/mocks/notificationsClient.mock';
// import { clientMock } from '@/assets/mocks/client.mock';


const URL = apiConstants.client;
const URL_APP = apiConstants.clientApp;
const URL_PANEL = apiConstants.clientsPanel;
const BILLING_URL = apiConstants.billingData;
const CREDIT_URL =  apiConstants.creditCards;
// const ADDRESS_URL = apiConstants.address;
// const ADDRESS_INMUTABLE_URL = apiConstants.addressInmutable;
// const NOTIFICATION_URL = apiConstants.notification;

const fetchAllClients = (page = null, filtro = '') => {
  let filter = filtro.length > 0 ? filtro : "";

  if (page != null) {
    return httpClient.get(`${URL_PANEL}?page=${page}${filter}`).then(res => res.data)
  }
  else {
    return httpClient.get(`${URL_PANEL}?${filter}`).then(res => res.data)
  }
};

const fetchOneClient = (clientId) => {

  // const data = clientMock;
  // return new Promise((resolve) => {
  //   resolve(data);
  // });

  return httpClient.get(`${URL}/${clientId}`).then(res => res.data);
};

const updateClient = (clientToEdit) => {
  return httpClient.put(`${URL}/${clientToEdit.id}`, clientToEdit).then(res => res.data);
};

const updateClientApp = (clientToEdit) => {
  return httpClient.put(`${URL_APP}/${CLIENT_API_CREDENTIALS.id}`, clientToEdit).then(res => res.data);
};

const getClientApp = (clientId) => {
  return httpClient.get(`${URL_APP}/${clientId}`).then(res => res.data);
};

const deleteClient = (clientId) => {
  return httpClient.delete(`${URL}/${clientId}`).then(res => res);
};

const downloadExcel = (filename) => {
  setResponseType('blob'); // arraybuffer
  return httpClient.post(`${URL_PANEL}/to-excel`, { name: filename }).then(res => {
    setResponseType('json');
    return res
  });
};

const resetResponseType = () => {
  setResponseType('json');
};

const fetchCreditCardAboutToExpired = (page = null) => {
  const URL = `${apiConstants.dashboard}/about-to-expire-credit-cards`;

  if (page != null) {
    return httpClient.get(`${URL_PANEL}?page=${page}`).then(res => res.data)
  }
  else {
    return httpClient.get(URL_PANEL).then(res => res.data)
  }
};

const fetchCreditCardExpired = (page = null) => {
  const URL = `${apiConstants.dashboard}/expired-credit-cards`;

  if (page != null) {
    return httpClient.get(`${URL_PANEL}?page=${page}`).then(res => res.data)
  }
  else {
    return httpClient.get(URL_PANEL).then(res => res.data)
  }
};


const addGroupClient = (groups_id, clients_id) => {
  return httpClient.post(`${URL_PANEL}/set-group`, { clients_id, groups_id }).then(res => res.data);
};

const deleteGroupClient = (clients_id) => {
  return httpClient.post(`${URL_PANEL}/set-group`, { clients_id }).then(res => res.data);
};

// Route::post('clients/add-new-credit-card/{id}'
// data.URL_REDIRECT
const newCardClient = (clients_id, tipo = null) => {
  // 4548 8120 4940 0004, caducidad 12/20, código CVV2: 533 // redsys

  /* 4548 8120 4940 0004, caducidad 05/22, código CVV2: 123
    Tarjeta 1:      4539     2320     7664     8253
    Tarjeta 2:      5445     2888     5220     0883
    Tarjeta 3:      6011     4546     3881     2167
    Tarjeta 4:      377       9600     9519     5350

  */

  /*

  from=MP / RC / CP 

  RC - registro cliente
  MP - método de pago
  CP - Contratar producto. nueva tarjeta en form contratación
  'PC' => 'PC000', // pay Custom
  'PE' => 'PE000', // pay extra
  */
  const type = tipo ? `${tipo}` : 'MP';

  return httpClient.post(`${URL}/add-new-credit-card/${clients_id}`, {from: type}).then(res => res.data);
  // return httpClient.post(`${URL}/add-new-credit-card/${clients_id}`, {}).then(res => res.data);
};

const newCardClientApp = (clients_id, tipo = null) => {

  const type = tipo ? tipo : 'RC';

  return httpClient.post(`${URL_APP}/add-new-credit-card/${clients_id}`, {from: type}).then(res => res.data);
};

const setCardDefault = ({clients_id, clients_cards_id}) => {
  ///api/client/clients/set-card-default
  return httpClient.post(`${URL}/set-card-default/${clients_id}`, { clients_cards_id }).then(res => res.data);
  // return httpClient.post(`${URL}/add-new-credit-card/${clients_id}`, {}).then(res => res.data);
};

const deleteCreditCard = ({ credit_cards_id }) => {
  return httpClient.delete(`${CREDIT_URL}/${credit_cards_id}`).then(res => res.data);
};

const editCreditCard = () => {
  setResponseType('text')
  return httpClient.post(URL + '/update-card', {}, { responseType: 'text' })
    .then((htmlForm) => {
      setResponseType('json');
      return htmlForm;
    });
};

const fetchCreditCards = (clients_id) => {
  const data = creditCardsMock.data;
  return new Promise((resolve, reject) => {
    resolve(data);
  });

  // return httpClient.post(`${URL}/me-credit-card/${clients_id}`, {}).then(res => res.data);
};


const getCurrentClient = () => {
  return httpClient.get(URL + '/me').then((resp) => resp.data);
};

const editCurrentClient = (data) => {
  return httpClient.put(URL + '/me', data).then((resp) => resp);
};



// Datos Facturación
const fetchBillingData = () => {

  return httpClient.get(`${BILLING_URL}`).then(res => res.data);
};

const createBillingData = (data) => {

  // /api/client/clients-billing-data

  const dataToCreate = {
    ...data,
    emails: JSON.stringify(data.emails)
  }

  return httpClient.post(`${BILLING_URL}`, dataToCreate).then(res => res.data);
};

const updateBillingData = (clientToEdit) => {
  // const emails = JSON.stringify(data.emails)

  // let dataToEdit = {
  //   ...data,
  //   emails: emails,
  //   company: data.company === '' ? null : data.company
  // }

  return httpClient.put(`${URL}/${clientToEdit.id}`, clientToEdit).then(res => res.data);

  // return httpClient.put(`${BILLING_URL}/${dataToEdit.id}`, dataToEdit).then(res => res.data);
};


const sendInvitation = (data) => {
  return httpClient.post(URL + '/send-invite/'+ localStorage.getItem('user_id'), data).then((resp) => resp.data);
};


const getWalletTransactions = (page = null) => {
  //wallets-transactions
  const URL = `${apiConstants.walletTransaction}`;

  if (page != null) {
    return httpClient.get(`${URL}?page=${page}`).then(res => res.data)
  }
  else {
    return httpClient.get(URL).then(res => res.data)
  }

};





export {

  fetchAllClients, // delete
  deleteClient,
  fetchCreditCardAboutToExpired, // delete
  fetchCreditCardExpired, // delete
  addGroupClient, // delete
  deleteGroupClient, // delete
  downloadExcel,
  resetResponseType,

  fetchOneClient,
  updateClient,
  getCurrentClient,
  updateClientApp,
  getClientApp,

  newCardClient,
  newCardClientApp,
  fetchCreditCards,
  setCardDefault,
  deleteCreditCard,

  createBillingData,
  updateBillingData,
  fetchBillingData,

  sendInvitation,
  getWalletTransactions
};
